/* KitchenBuildr: Get a quote form.
   Friendly validation, plus optional file uploads when an endpoint is configured. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.__kbqReady) return;
    root.__kbqReady = true;

    var form = root.querySelector('form');
    var success = root.querySelector('[data-kbq-success]');
    var errorBox = root.querySelector('[data-kbq-error]');
    if (success) success.focus();
    else if (errorBox) errorBox.focus();
    if (!form) return;

    /* ---------- Validation, in the field rather than at the top ---------- */
    function digits(value) { return String(value || '').replace(/\D/g, ''); }

    /* A required phone field needs a usable number, not just any character */
    function phoneProblem(field) {
      if (field.type !== 'tel' || !field.required) return '';
      var count = digits(field.value).length;
      if (count === 0) return 'Please fill this in.';
      if (count < 10) return 'Please enter a full mobile number, including the area or country code.';
      if (count > 15) return 'That number looks too long.';
      return '';
    }

    function valid(field) {
      if (!field.checkValidity()) return false;
      return phoneProblem(field) === '';
    }

    function message(field) {
      var phone = phoneProblem(field);
      if (phone) return phone;
      if (field.validity.valueMissing) {
        if (field.type === 'checkbox') return 'Please tick this to carry on.';
        return 'Please fill this in.';
      }
      if (field.validity.typeMismatch && field.type === 'email') return 'That email address doesn\'t look right.';
      return field.validationMessage || 'Please check this.';
    }

    function showError(field) {
      clearError(field);
      var holder = field.closest('.kbq-field') || field.closest('.kbq-check');
      if (!holder) return;
      var note = document.createElement('span');
      note.className = 'kbq-field__error';
      note.textContent = message(field);
      holder.appendChild(note);
      field.classList.add('is-invalid');
      field.setAttribute('aria-invalid', 'true');
    }

    function clearError(field) {
      var holder = field.closest('.kbq-field') || field.closest('.kbq-check');
      var note = holder && holder.querySelector('.kbq-field__error');
      if (note) note.remove();
      field.classList.remove('is-invalid');
      field.removeAttribute('aria-invalid');
    }

    form.addEventListener('submit', function (e) {
      var bad = null;
      Array.prototype.forEach.call(form.querySelectorAll('[required]'), function (field) {
        if (valid(field)) clearError(field);
        else { showError(field); if (!bad) bad = field; }
      });
      if (bad) {
        e.preventDefault();
        bad.focus();
        bad.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      /* Let the upload guard deal with it if files are still going up */
      if (root.__kbqPending && root.__kbqPending() > 0) return;

      var button = form.querySelector('[data-kbq-submit]');
      if (button) { button.disabled = true; button.textContent = 'Sending…'; }

      /* Send to Klaviyo first, then submit to Shopify */
      if (root.dataset.klaviyoKey && !form.__kbqTracked) {
        e.preventDefault();
        form.__kbqTracked = true;
        var sent = false;
        var go = function () { if (sent) return; sent = true; HTMLFormElement.prototype.submit.call(form); };
        var timer = setTimeout(go, 2500);            /* never hold the customer up */
        trackQuote().then(function () { clearTimeout(timer); go(); }, function () { clearTimeout(timer); go(); });
      }
    });

    /* ---------- Klaviyo: form submission event ---------- */
    function ukPhone(value) {
      var raw = String(value || '').replace(/[^\d+]/g, '');
      if (/^\+\d{10,15}$/.test(raw)) return raw;
      if (/^0\d{10}$/.test(raw)) return '+44' + raw.slice(1);
      if (/^44\d{10}$/.test(raw)) return '+' + raw;
      return '';                                     /* Klaviyo rejects anything not E.164 */
    }

    function klaviyo(path, payload) {
      return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + encodeURIComponent(root.dataset.klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', revision: '2024-10-15' },
        body: JSON.stringify(payload),
        keepalive: true
      });
    }

    function trackQuote() {
      var props = {};
      new FormData(form).forEach(function (value, key) {
        var m = key.match(/^contact\[(.+)\]$/);
        if (m && value !== '') props[m[1]] = value;
      });

      var email = (props.email || '').trim();
      if (!email) return Promise.resolve();

      var fullName = (props.Name || '').trim();
      var first = fullName.split(/\s+/)[0] || '';
      var last = fullName.split(/\s+/).slice(1).join(' ');
      var phone = ukPhone(props.Phone || props.Mobile);

      var profile = { email: email, first_name: first, last_name: last };
      if (props.Postcode) profile.location = { zip: props.Postcode };
      if (phone) profile.phone_number = phone;

      var eventProps = {};
      Object.keys(props).forEach(function (k) { if (k !== 'email') eventProps[k] = props[k]; });
      eventProps.Page = window.location.href;

      var calls = [klaviyo('events', {
        data: {
          type: 'event',
          attributes: {
            properties: eventProps,
            unique_id: 'kbq-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8),
            metric: { data: { type: 'metric', attributes: { name: root.dataset.klaviyoEvent || 'Quote Requested' } } },
            profile: { data: { type: 'profile', attributes: profile } }
          }
        }
      })];

      /* Only subscribe if they ticked the marketing box and a list is set */
      if (props['Accepts Marketing'] === 'Yes' && root.dataset.klaviyoList) {
        calls.push(klaviyo('subscriptions', {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'KitchenBuildr quote form',
              profile: { data: { type: 'profile', attributes: { email: email } } }
            },
            relationships: { list: { data: { type: 'list', id: root.dataset.klaviyoList } } }
          }
        }));
      }

      return Promise.all(calls);
    }

    form.addEventListener('input', function (e) {
      if (e.target.classList && e.target.classList.contains('is-invalid') && valid(e.target)) clearError(e.target);
    });

    /* ---------- Prefill from a "Request a price" link ---------- */
    (function () {
      var field = root.querySelector('[data-kbq-product]');
      var holder = root.querySelector('[data-kbq-product-field]');
      if (!field || !holder) return;
      var params = new URLSearchParams(window.location.search);
      var handle = params.get('product');
      var sku = params.get('sku');
      if (!handle && !sku) return;

      var name = handle ? handle.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); }) : '';
      field.value = [name, sku ? '(' + sku + ')' : ''].filter(Boolean).join(' ');
      holder.hidden = false;

      var body = root.querySelector('#kbq-body');
      if (body && !body.value) body.value = 'Please can you price ' + field.value + '?\n\n';
    })();

    /* ---------- Uploads (only when an endpoint is set) ---------- */
    var uploadUrl = root.dataset.uploadUrl;
    var box = root.querySelector('[data-kbq-upload]');
    if (!box || !uploadUrl) return;

    var input = box.querySelector('[data-kbq-input]');
    var zone = box.querySelector('[data-kbq-zone]');
    var list = box.querySelector('[data-kbq-list]');
    var store = box.querySelector('[data-kbq-uploaded]');
    var limits = box.querySelector('[data-kbq-limits]');
    var errorLine = box.querySelector('[data-kbq-upload-error]');
    var maxFiles = Number(root.dataset.maxFiles) || 8;
    var maxMb = Number(root.dataset.maxMb) || 10;
    var accept = (root.dataset.accept || '').split(',').map(function (t) { return t.trim().toLowerCase(); }).filter(Boolean);
    var mode = root.dataset.uploadMode || 'direct';   /* 'direct' = one POST, 'staged' = presign then S3 */
    var files = [];          /* { name, url } */
    var inFlight = 0;
    root.__kbqPending = function () { return inFlight; };

    /* Extra fields the storage provider needs, e.g. upload_preset=kitchenbuildr */
    var extras = {};
    (root.dataset.uploadFields || '').split(/\r?\n/).forEach(function (line) {
      var i = line.indexOf('=');
      if (i > 0) extras[line.slice(0, i).trim()] = line.slice(i + 1).trim();
    });

    box.hidden = false;
    if (limits) {
      var pretty = accept.length
        ? accept.map(function (t) { return t.replace('.', '').toUpperCase(); }).join(', ')
        : 'JPG, PNG or PDF';
      limits.textContent = 'Up to ' + maxFiles + ' files, ' + maxMb + 'MB each. ' + pretty + '.';
    }

    function sync() {
      store.value = files.map(function (f) { return f.name + ' — ' + f.url; }).join('\n');
    }

    function problem(text) {
      if (!errorLine) return;
      errorLine.textContent = text;
      errorLine.hidden = !text;
    }

    function allowed(file) {
      if (!accept.length) return true;
      var name = file.name.toLowerCase();
      return accept.some(function (t) {
        return t.charAt(0) === '.' ? name.slice(-t.length) === t : (file.type || '').indexOf(t.replace('/*', '')) === 0;
      });
    }

    function icon(file) {
      var ext = (file.name.split('.').pop() || '').toUpperCase().slice(0, 4);
      var span = document.createElement('span');
      span.className = 'kbq-file__icon';
      span.textContent = ext;
      return span;
    }

    function thumb(file, li) {
      if (!/^image\//.test(file.type) || !window.FileReader) return;
      var reader = new FileReader();
      reader.onload = function () {
        var img = document.createElement('img');
        img.className = 'kbq-file__thumb';
        img.src = reader.result;
        img.alt = '';
        var placeholder = li.querySelector('.kbq-file__icon');
        if (placeholder) li.replaceChild(img, placeholder);
      };
      reader.readAsDataURL(file);
    }

    function row(file) {
      var li = document.createElement('li');
      li.appendChild(icon(file));

      var text = document.createElement('span');
      text.className = 'kbq-file__text';
      var name = document.createElement('span');
      name.className = 'kbq-file__name';
      name.textContent = file.name;
      var state = document.createElement('span');
      state.className = 'kbq-file__state';
      state.textContent = 'Uploading…';
      text.appendChild(name);
      text.appendChild(state);
      li.appendChild(text);

      var bar = document.createElement('span');
      bar.className = 'kbq-file__bar';
      bar.innerHTML = '<span></span>';
      li.appendChild(bar);

      list.appendChild(li);
      thumb(file, li);
      return li;
    }

    function removeButton(li, entry) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'kbq-file__remove';
      button.setAttribute('aria-label', 'Remove ' + entry.name);
      button.textContent = '×';
      button.addEventListener('click', function () {
        files = files.filter(function (f) { return f !== entry; });
        sync();
        li.remove();
        problem('');
      });
      li.appendChild(button);
    }

    function done(li, state, fill, entry) {
      files.push(entry);
      sync();
      li.classList.add('is-done');
      state.textContent = 'Added';
      state.classList.add('is-done');
      if (fill) fill.style.width = '100%';
      removeButton(li, entry);
    }

    function failed(li, state, file, detail) {
      li.classList.add('is-error');
      state.textContent = 'Upload failed';
      state.classList.add('is-error');
      problem(detail || ('We couldn\'t upload ' + file.name + '. Try again, or paste a link below instead.'));
    }

    /* POST the file itself, with progress */
    function put(url, data, onProgress) {
      return new Promise(function (resolve, reject) {
        var request = new XMLHttpRequest();
        request.open('POST', url, true);
        request.upload.addEventListener('progress', function (e) {
          if (e.lengthComputable && onProgress) onProgress(e.loaded / e.total);
        });
        request.addEventListener('load', function () {
          if (request.status >= 200 && request.status < 300) resolve(request.responseText);
          else reject(new Error('Upload rejected (' + request.status + ')'));
        });
        request.addEventListener('error', function () { reject(new Error('Network error')); });
        request.send(data);
      });
    }

    function ask(path, payload) {
      return fetch(uploadUrl.replace(/\/+$/, '') + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok || body.error) throw new Error(body.error || 'Upload service error');
          return body;
        });
      });
    }

    function send(file) {
      if (files.length + inFlight >= maxFiles) { problem('That\'s the maximum of ' + maxFiles + ' files.'); return; }
      if (!allowed(file)) { problem(file.name + ' isn\'t a file type we can take.'); return; }
      if (file.size > maxMb * 1024 * 1024) { problem(file.name + ' is larger than ' + maxMb + 'MB.'); return; }
      problem('');

      var li = row(file);
      var state = li.querySelector('.kbq-file__state');
      var fill = li.querySelector('.kbq-file__bar span');
      var progress = function (ratio) { if (fill) fill.style.width = Math.round(ratio * 100) + '%'; };
      inFlight++;

      if (mode === 'staged') {
        /* Shopify's own S3 bucket: ask for a signed target, upload, then file it */
        ask('/presign', { filename: file.name, mimeType: file.type || 'application/octet-stream', fileSize: file.size })
          .then(function (target) {
            var data = new FormData();
            (target.parameters || []).forEach(function (p) { data.append(p.name, p.value); });
            data.append('file', file);
            return put(target.uploadUrl, data, progress).then(function () { return target.resourceUrl; });
          })
          .then(function (resourceUrl) {
            state.textContent = 'Filing…';
            return ask('/finalise', { resourceUrl: resourceUrl, filename: file.name, mimeType: file.type });
          })
          .then(function (result) {
            inFlight--;
            done(li, state, fill, { name: file.name, url: result.url || result.id });
          })
          .catch(function (err) { inFlight--; failed(li, state, file, err && err.message); });
        return;
      }

      /* One POST to a storage endpoint (Cloudinary and the like) */
      var data = new FormData();
      Object.keys(extras).forEach(function (key) { data.append(key, extras[key]); });
      data.append('file', file);

      put(uploadUrl, data, progress)
        .then(function (text) {
          var body = {};
          try { body = JSON.parse(text); } catch (err) {}
          var url = body.url || body.secure_url || body.location || body.link || (body.data && body.data.url);
          if (!url) throw new Error('The upload service didn\'t return a link');
          inFlight--;
          done(li, state, fill, { name: file.name, url: url });
        })
        .catch(function (err) { inFlight--; failed(li, state, file, err && err.message); });
    }

    function take(fileList) { Array.prototype.forEach.call(fileList, send); }

    input.addEventListener('change', function () { take(input.files); input.value = ''; });

    ['dragenter', 'dragover'].forEach(function (name) {
      zone.addEventListener(name, function (e) { e.preventDefault(); zone.classList.add('is-over'); });
    });
    ['dragleave', 'drop'].forEach(function (name) {
      zone.addEventListener(name, function (e) { e.preventDefault(); zone.classList.remove('is-over'); });
    });
    zone.addEventListener('drop', function (e) {
      if (e.dataTransfer && e.dataTransfer.files) take(e.dataTransfer.files);
    });

    /* Don't let the form post while files are still going up */
    form.addEventListener('submit', function (e) {
      if (inFlight > 0) {
        e.preventDefault();
        problem('Hold on, your files are still uploading.');
        var button = form.querySelector('[data-kbq-submit]');
        if (button) { button.disabled = false; button.textContent = root.dataset.submitLabel || 'Send my quote request'; }
      }
    });
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-kbq]'), init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();